import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { thaiUser } from "../utils/thaiUser";
import toast from "react-hot-toast";

const AppleSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const token = params.get("token");
      if (!token) {
        toast.error("เข้าสู่ระบบด้วย Apple ไม่สำเร็จ (ไม่พบโทเค็น)");
        navigate("/login");
        return;
      }

      localStorage.setItem("token", token);

      // ✅ fetch user (so your app recognizes session)
      const res = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        localStorage.removeItem("token");
        toast.error("ตั้งค่าเซสชันไม่สำเร็จ");
        navigate("/login");
        return;
      }

      const data = await res.json();
      localStorage.setItem("user", JSON.stringify(thaiUser(data.user)));

      toast.success("เข้าสู่ระบบด้วย Apple สำเร็จ");
      navigate("/");
    };

    run();
  }, [params, navigate]);

  return null;
};

export default AppleSuccess;
